// extracted by mini-css-extract-plugin
module.exports = {"forgotPassword":"uylQ-QWK0oIEHSiu7A5QO","content":"_2XAH9Oc_vvIuOdFCLYAHeF","logo":"Ef4OBMf2hSG78Yp2s-64_","title":"vn9843yIlxQw0STUVLfP6"};